import React, { useEffect, useRef, useState } from "react";
import { GET_ALL_JODI_CHART } from "../../service/admin.service";
import Navbar from "../../Pages/Navbar/Navbar";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Footer from "../../Pages/Footer/Footer";
import stars from "../../../RichImages/stars.svg";
import back from "../../../RichImages/back.svg";
import MayaMorning from "../../Charts/JodiCharts/MayaMorning";
import INDRADAY from "../../Charts/JodiCharts/INDRADAY";
import INDRANIGHT from "../../Charts/JodiCharts/INDRANIGHT";
import MAYADAY from "../../Charts/JodiCharts/MAYADAY";
import MAYANIGHT from "../../Charts/JodiCharts/MAYANIGHT";
import VEDAMORNING from "../../Charts/JodiCharts/VEDAMORNING";
import VEDADAY from "../../Charts/JodiCharts/VEDADAY";
import VEDANIGHT from "../../Charts/JodiCharts/VEDANIGHT";
import YUGMORNING from "../../Charts/JodiCharts/YUGMORNING";
import YUGDAY from "../../Charts/JodiCharts/YUGDAY";
import DHARMMORNING from "../../Charts/JodiCharts/DHARMMORNING";
import DHARMDAY from "../../Charts/JodiCharts/DHARMDAY";
import YUGNIGHT from "../../Charts/JodiCharts/YUGNIGHT";
import DHARMNIGHT from "../../Charts/JodiCharts/DHARMNIGHT";
import { GetAllCharts } from "../../Helpers/GetCharts";
import { common_chart_url } from "../../Config/config";

const Pana_Chart = () => {
  const navigate = useNavigate();
  const { title } = useParams();
  const location = useLocation();

  const [getData, setgetData] = useState([]);
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState("0px");
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  const handleClick = () => {
    const targetElement = document.getElementById("scroll-down");

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const normalize = (str) =>
    str?.replace(/-/g, "").replace(/\s+/g, "").toUpperCase();

  const normalizedTitle = normalize(title);

  const getResponseData = async () => {
    const req = location.state;

    // const res = await GET_ALL_GAMES_RESULT({ id: req });
    const res = await GetAllCharts(GET_ALL_JODI_CHART, req);
    setgetData(res);
  };

  useEffect(() => {
    if (title) getResponseData();
  }, [title]);

  const chartMap = {
    // Maya
    MAYAMORNING: MayaMorning,
    MAYANIGHT: MAYANIGHT,
    MAYADAY: MAYADAY,

    // Indra
    // INDRAMORNING: INDRAMORNING,
    INDRANIGHT: INDRANIGHT,
    INDRADAY: INDRADAY,

    // Ved
    VEDAMORNING: VEDAMORNING,
    VEDANIGHT: VEDANIGHT,
    VEDADAY: VEDADAY,

    // Yug
    YUGMORNING: YUGMORNING,
    YUGDAY: YUGDAY,
    YUGNIGHT: YUGNIGHT,

    // Dharm
    DHARMMORNING: DHARMMORNING,
    DHARMDAY: DHARMDAY,
    DHARMNIGHT: DHARMNIGHT,
  };

  const ChartComponent = chartMap[normalizedTitle];

  // 🌐 iframe fallback (TITLE BASED)
  const chartUrl = `${common_chart_url}jodi-chart/${normalizedTitle}?embed=true&color=linear-gradient%28to%20bottom%2C%20%235ebdc4%2C%20%23a3dadd%29`;

  // iframe height listener
  useEffect(() => {
    if (ChartComponent) return;

    const handleMessage = (event) => {
      if (event.data?.type === "SET_HEIGHT") {
        const newHeight = `${event.data.height}px`;
        setIframeHeight(newHeight);
        if (iframeRef.current) {
          iframeRef.current.style.height = newHeight;
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [ChartComponent]);

  return (
    <>
      <div id="scroll-up"></div>
      <Navbar />
      <div className="container-fluid">
        <div className="row">
          <div className="text-center col-xl-12 col-q-12 col-md-12 col-sm-12 chart-header ">
            <div className="">
              <div className="d-flex justify-content-center align-items-center">
                <img
                  className="game-icons-img"
                  style={{ height: "25px" }}
                  src={stars}
                  alt="https://rich143.com/"
                />
                <h1
                  class="mb-0 ms-2 me-2 rich-game-title"
                  style={{ color: "#075358", fontSize: "28px" }}
                >
                  {normalizedTitle}
                </h1>
                <img
                  className="game-icons-img"
                  style={{ height: "25px" }}
                  src={stars}
                  alt="https://rich143.com/"
                />
              </div>

              <p style={{ fontWeight: 600 }}>
                Explore {normalizedTitle} Jodi Chart with previous records,
                result history, and live chart information for easy tracking and
                updates.
              </p>
            </div>
            <button
              class="download-button"
              style={{ paddingLeft: "35px", paddingRight: "35px" }}
              onClick={handleClick}
              id="scroll-down-button"
            >
              Go To Bottom&nbsp;
              <svg
                width="16"
                height="11"
                viewBox="0 0 16 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.8188 0.409424L8 6.22817L2.18125 0.409424L0 2.59067L8 10.5907L16 2.59067L13.8188 0.409424Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className=" ">
        <div className="row justify-content-center">
          <div className=" p-0 text-center d-flex justify-content-center   col-xl-12 col-q-12 col-md-12 col-sm-12 ">
            <div className="table-responsive  text-center col-xl-8 col-lg-12 col-md-12 col-sm-12 ">
              {ChartComponent ? (
                <ChartComponent chartData={getData.data} />
              ) : (
                <div
                  style={{
                    minHeight: iframeHeight === "0px" ? "200px" : iframeHeight,
                    position: "relative",
                  }}
                >
                  {/* Skeleton Loader */}
                  {isIframeLoading && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        padding: "20px",
                        background: "#fff",
                        zIndex: 10,
                      }}
                    >
                      <div className="skeleton-box"></div>
                      <div className="skeleton-box"></div>
                      <div className="skeleton-box"></div>
                    </div>
                  )}

                  {/* iframe */}
                  <iframe
                    ref={iframeRef}
                    src={chartUrl}
                    title="Charts"
                    onLoad={() => setIsIframeLoading(false)}
                    className="w-100 border-0 transition-all duration-500"
                    scrolling="no"
                    style={{
                      width: "100%",
                      height: iframeHeight,
                      opacity: isIframeLoading ? 0 : 1,
                    }}
                  />
                </div>
              )}

              <div className="d-flex justify-content-center">
                <button
                  class="download-button"
                  style={{ paddingLeft: "35px", paddingRight: "35px" }}
                  onClick={() => navigate(-1)}
                  id="scroll-down-button"
                >
                  Back &nbsp;
                  <img style={{ width: "10px" }} src={back} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <div id="scroll-down"></div>
    </>
  );
};

export default Pana_Chart;
